import { Fade, Box, Typography, TextField, Button, useMediaQuery } from "@mui/material";
import { FC, useEffect, useRef } from "react";


function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
}

interface Step2Props {
    activeStep: number;
    furnitureName: string;
    furnitureSymbol: string;
    purchaseDate: string;
    purchaseProof: string;
    serialNumber: string;
    handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    handleNext: () => void;
    handleBack: () => void;
}

const Step2: FC<Step2Props> = ({
    activeStep,
    furnitureName,
    furnitureSymbol,
    purchaseDate,
    purchaseProof,
    serialNumber,
    handleChange,
    handleNext,
    handleBack
}) => {
    const stepRef = useRef<HTMLDivElement>(null);
    const isMobile = useMediaQuery("(max-width:550px)");
     const dateInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (activeStep === 1 && stepRef.current && isMobile) {
            const top = stepRef.current.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top, behavior: "smooth" });
        }
    }, [activeStep, isMobile]);;
    return (
        <Fade in={activeStep === 1} unmountOnExit>
            <Box sx={{ display: activeStep === 1 ? "flex" : "none", flexDirection: "column", gap: 2 }}>
                <Typography variant="h6" fontWeight={600} color="#bfa14b" mb={1} ref={stepRef}>
                    Szczegóły produktu
                </Typography>
                <TextField
                    label="Nazwa mebla"
                    name="furnitureName"
                    value={furnitureName}
                    onChange={handleChange}
                    required
                />
                <TextField
                    label="Symbol mebla"
                    name="furnitureSymbol"
                    value={furnitureSymbol}
                    onChange={handleChange}
                />
                {isIOS() ? (
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                        <label htmlFor="purchaseDate" style={{ fontSize: 14, color: "#666", marginBottom: 2 }}>
                            Data zakupu <span style={{ color: "#d32f2f" }}>*</span>
                        </label>
                        <input
                            ref={dateInputRef}
                            id="purchaseDate"
                            name="purchaseDate"
                            type="date"
                            value={purchaseDate}
                            onChange={handleChange}
                            required
                            style={{
                                minHeight: 70,
                                borderRadius: 6,
                                border: "1px solid #ccc",
                                padding: "18px 12px",
                                fontSize: 16,
                                fontFamily: "inherit",
                                color: "#222", 
                                background: 'white'
                            }}
                        />
                    </Box>
                ) : (
                    <TextField
                        sx={{ minHeight: '50px' }}
                        label="Data zakupu"
                        name="purchaseDate"
                        value={purchaseDate}
                        onChange={handleChange}
                        required
                        type="date"
                        InputLabelProps={{ shrink: true }}
                    />
                )}
                <TextField
                    label="Dowód zakupu"
                    name="purchaseProof"
                    value={purchaseProof}
                    onChange={handleChange}
                    required
                />
                <TextField
                    label="Numer seryjny mebla"
                    name="serialNumber"
                    value={serialNumber}
                    onChange={handleChange}
                />
                <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                    <Button
                        variant="outlined"
                        sx={{
                            borderColor: "#bfa14b",
                            color: "#bfa14b",
                            fontWeight: 600,
                            borderRadius: 2,
                            "&:hover": { borderColor: "#a88d36", color: "#a88d36" }
                        }}
                        onClick={handleBack}
                    >
                        Wstecz
                    </Button>
                    <Button
                        variant="contained"
                        sx={{
                            bgcolor: "#bfa14b",
                            color: "#fff",
                            fontWeight: 600,
                            px: 4,
                            borderRadius: 2,
                            boxShadow: "0 2px 8px rgba(191,161,75,0.12)",
                            "&:hover": { bgcolor: "#a88d36" }
                        }}
                        onClick={handleNext}
                        disabled={
                            !furnitureName ||
                            !purchaseDate ||
                            !purchaseProof
                        }
                    >
                        Dalej
                    </Button>
                </Box>
            </Box>
        </Fade>
    )
}

export default Step2;